import React from "react";
import './AboutPage.css';

const AboutSection = () => (
  <section className="about-hero">
    <div className="about-hero-content">
      <h1 className="about-main-title">About ColorFuel</h1>
      <p className="about-subtitle">BRIDGING THE FUTURE OF DIGITAL ART</p>
      <div className="title-underline"></div>
      <p className="about-description">
        ColorFuel is a revolutionary digital art platform that seamlessly bridges the Solana and Ethereum blockchains. 
        Our mission is to empower artists and collectors with innovative tools for creating, trading, and collecting unique digital artworks.
      </p>
    </div>
  </section>
);

const FAQs = [
  {
    question: "What is ColorFuel?",
    answer: "ColorFuel is a unique digital art project that bridges Solana and Ethereum blockchains. We enable NFT minting on Solana and NFT trading on Ethereum, providing a diverse ecosystem for digital art collectors.",
    number: "01"
  },
  {
    question: "How can I create my own ColorFuel NFT?",
    answer: "Coming soon! Soon, every Web3 enthusiast will be able to create their own unique NFTs and take them anywhere across the Solana ecosystem, including all major NFT marketplaces. Join us in building the immersive ColorFuel universe.",
    number: "02"
  },
  {
    question: "How do I make offers on existing NFTs?",
    answer: "You can make offers on ColorFuel NFTs through our Ethereum integration. Connect your Ethereum wallet to browse and place offers on existing collections using ETH.",
    number: "03"
  },
  {
    question: "Where can I view my ColorFuel NFTs?",
    answer: "For Solana-minted NFTs, you can view them in any Solana wallet or marketplace like Magic Eden or Tensor. For Ethereum trading, connect your Ethereum wallet to view offers and transactions.",
    number: "04"
  },
  {
    question: "How can I contact the team?",
    answer: "For any inquiries, please email us at contact@colorfuel.art",
    number: "05"
  }
];

const AboutPage = () => {
  return (
    <div className="about-page-wrapper">
      <AboutSection />
      
      <div className="about-content-container">
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-card-content">
              <span className="feature-icon">🎨</span>
              <h3>Create</h3>
              <p>Mint your NFTs on Solana with low fees and fast transactions</p>
              <div className="card-footer-line"></div>
            </div>
          </div>
          <div className="feature-card">
            <div className="feature-card-content">
              <span className="feature-icon">💎</span>
              <h3>Trade</h3>
              <p>Make offers on Ethereum for seamless global trading</p>
              <div className="card-footer-line"></div>
            </div>
          </div>
          <div className="feature-card">
            <div className="feature-card-content">
              <span className="feature-icon">🌐</span>
              <h3>Connect</h3>
              <p>Join a vibrant community of artists and collectors</p>
              <div className="card-footer-line"></div>
            </div>
          </div>
        </div>

        <section className="faq-section">
          <h2 className="faq-main-title">FAQ</h2>
          <div className="faq-list">
            {FAQs.map((faq, index) => (
              <div key={index} className="faq-item">
                <div className="faq-number">{faq.number}</div>
                <div className="faq-content">
                  <h3>{faq.question}</h3>
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="contact-section">
          <div className="contact-box">
            <h2>Join Our Community</h2>
            <p>Stay updated with the latest drops and features.</p>
            <a href="https://x.com/ColorFuel_Art" className="social-button" target="_blank" rel="noopener noreferrer">
              FOLLOW ON X
            </a>
          </div>
        </section>
      </div>
    </div>
  );
}

export default AboutPage;